/** Light / dark / auto (follow the device). Remembered per device; applied before first paint by index.html. */
export type ThemePref = 'light' | 'dark' | 'auto';
const KEY = 'ly360.theme';
/** Fired on window whenever the theme changes, so every switch on the page shows the same choice. */
export const THEME_EVENT = 'ly360:theme';

export function getThemePref(): ThemePref {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'light' || v === 'dark' ? v : 'auto';
  } catch {
    return 'auto';
  }
}

export function setThemePref(pref: ThemePref) {
  const root = document.documentElement;
  if (pref === 'auto') delete root.dataset.theme;
  else root.dataset.theme = pref;
  window.dispatchEvent(new Event(THEME_EVENT));
  try {
    if (pref === 'auto') localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, pref);
  } catch {
    /* storage blocked: the choice applies to this page view only */
  }
}
